if (!customElements.get('c-card-slider')) {
  class ComponentCardSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.btnPrev = this.querySelector(".js-card-slider__button--prev");
      this.btnNext = this.querySelector(".js-card-slider__button--next");

      this.glide = new Glide(this, {
        type: 'slider',
        startAt: 0,
        perView: 1
      });

      this.glide.mount();

      if (this.classList.contains("is-bundle")) {
        this.glide.disable()
      }

      this.btnPrev.addEventListener("click", this.slideChanger.bind(this, "<"))
      this.btnNext.addEventListener("click", this.slideChanger.bind(this, ">"))
    }

    disconnectedCallback() {

    }

    slideChanger = (dir) => {
      this.glide.go(dir)
    }
  }

  customElements.define('c-card-slider', ComponentCardSlider);
}

if (!customElements.get('c-bundle-slider')) {
  class ComponentBundleSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.glide = new Glide(this, {
        type: 'slider',
        bound: true,
        perView: 2.5,
        breakpoints: {
          1024: {
            perView: 2
          },
          600: {
            perView: 2.3
          }
        }
      });

      this.glide.mount();


      this.isScrolling = false; 

      this.addEventListener('wheel', (e) => {
        if (this.isScrolling) return;
    
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          e.preventDefault(); 
    
          this.isScrolling = true;
    
          if (e.deltaX > 0) {
            this.glide.go('>'); 
          } else {
            this.glide.go('<'); 
          }
    
          setTimeout(() => {
            this.isScrolling = false;
          }, 300);
        }
      }, { passive: false });
    }
  }

  customElements.define('c-bundle-slider', ComponentBundleSlider);
}
